/* eslint-disable */
import { Subject } from "rxjs";
import { Field } from "./vforms-model";

export abstract class FieldPreviewComponent {
    protected _unsubscribeAll: Subject<any> = new Subject<any>();

    field: Field;
}
